import bootstrapper from '../bootstrapper';

const formatAmount = (amount) => {
  let formattedAmount = amount.replace(/[^0-9.,]/g, '');
  let decimalPart = false;
  const lastComma = formattedAmount.lastIndexOf(',');
  const lastPoint = formattedAmount.lastIndexOf('.');

  if (lastComma > lastPoint) {
    if (formattedAmount.split(',').at(-1).length === 2) { decimalPart = true; }
    formattedAmount = formattedAmount.replace(/\./g, '').replace(/,/, '.');
  } else if (lastPoint > lastComma) {
    if (formattedAmount.split('.').at(-1).length === 2) { decimalPart = true; }
    formattedAmount = formattedAmount.replace(/,/g, '');
  } else {
    formattedAmount = formattedAmount.replace(/[.,]/g, '');
  }
  if (!decimalPart) { formattedAmount = formattedAmount.replace(/\./g, ''); }

  return { formattedAmount, decimalPart };
};

export default () => {
  const { numberLocalizedEnabled } = bootstrapper;

  if (numberLocalizedEnabled) {
    const locale = navigator.language;
    const prices = document.querySelectorAll('.js-number-localized');

    prices.forEach((price) => {
      const { formattedAmount, decimalPart } = formatAmount(price.innerHTML);
      const currency = price.innerHTML.replace(/[0-9]/g, '').replace(/,/g, '').replace(/\./g, '');

      const options = { numberingSystem: 'latn' };
      if (decimalPart) { options.minimumFractionDigits = 2; }
      const formattedPrice = Intl.NumberFormat(locale, options).format(formattedAmount);

      if (!(currency === '%')) {
        price.innerHTML = currency + formattedPrice;
      }
    });
  }
};
